import React from 'react';

const Stats = ({ stats, loading }) => {
  if (loading && !stats) {
    return (
      <div className="stats">
        <div className="loading">Loading statistics...</div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="stats">
        <div className="stats-card">
          <h2>No Statistics Available</h2>
          <p>Unable to load statistics from the database.</p>
        </div>
      </div>
    );
  }

  const getPlayRate = () => {
    if (stats.total_songs === 0) return 0;
    return (stats.total_plays / stats.total_songs).toFixed(1);
  };

  const getMostPlayedPercentage = () => {
    if (stats.total_plays === 0) return 0;
    return ((stats.most_played_count / stats.total_plays) * 100).toFixed(1);
  };

  return (
    <div className="stats">
      <h2>Statistics</h2>
      
      <div className="stats-grid">
        <div className="stats-card primary">
          <div className="stats-icon">🎵</div>
          <div className="stats-content">
            <div className="stats-number">{stats.total_songs}</div>
            <div className="stats-label">Total Songs</div>
          </div>
        </div>

        <div className="stats-card primary">
          <div className="stats-icon">▶️</div>
          <div className="stats-content">
            <div className="stats-number">{stats.total_plays}</div>
            <div className="stats-label">Total Plays</div>
          </div>
        </div>

        <div className="stats-card secondary">
          <div className="stats-icon">📊</div>
          <div className="stats-content">
            <div className="stats-number">{getPlayRate()}</div>
            <div className="stats-label">Avg Plays per Song</div>
          </div>
        </div>

        <div className="stats-card secondary">
          <div className="stats-icon">⭐</div>
          <div className="stats-content">
            <div className="stats-number">{getMostPlayedPercentage()}%</div>
            <div className="stats-label">Most Played Share</div>
          </div>
        </div>
      </div>

      {stats.most_played && (
        <div className="most-played-card">
          <h3>🏆 Most Played Song</h3>
          <div className="most-played-content">
            <div className="song-title">{stats.most_played}</div>
            <div className="play-count">
              Played {stats.most_played_count} time{stats.most_played_count !== 1 ? 's' : ''}
            </div>
            <div className="play-percentage">
              {getMostPlayedPercentage()}% of all plays
            </div>
          </div>
        </div>
      )}

      <div className="stats-info">
        <h3>About These Statistics</h3>
        <ul>
          <li>Statistics are updated in real-time as songs are played</li>
          <li>Play counts are tracked per song in the database</li>
          <li>Most played song shows the song with the highest play count</li>
          <li>Average plays per song is calculated as total plays ÷ total songs</li>
        </ul>
      </div>
    </div>
  );
};

export default Stats;
